/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManageContributionsRequestEditsInner
 */
export interface ManageContributionsRequestEditsInner {
    /**
     * 
     * @type {string}
     * @memberof ManageContributionsRequestEditsInner
     */
    op: ManageContributionsRequestEditsInnerOpEnum;
    /**
     * 
     * @type {string}
     * @memberof ManageContributionsRequestEditsInner
     */
    role: string;
    /**
     * Required for add; from lookup_client_aliases response
     * @type {string}
     * @memberof ManageContributionsRequestEditsInner
     */
    personaId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManageContributionsRequestEditsInner
     */
    dataCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManageContributionsRequestEditsInner
     */
    sourceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManageContributionsRequestEditsInner
     */
    notes?: string | null;
}


/**
 * @export
 */
export const ManageContributionsRequestEditsInnerOpEnum = {
    Add: 'add',
    Delete: 'delete',
    Edit: 'edit'
} as const;
export type ManageContributionsRequestEditsInnerOpEnum = typeof ManageContributionsRequestEditsInnerOpEnum[keyof typeof ManageContributionsRequestEditsInnerOpEnum];


/**
 * Check if a given object implements the ManageContributionsRequestEditsInner interface.
 */
export function instanceOfManageContributionsRequestEditsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function ManageContributionsRequestEditsInnerFromJSON(json: any): ManageContributionsRequestEditsInner {
    return ManageContributionsRequestEditsInnerFromJSONTyped(json, false);
}

export function ManageContributionsRequestEditsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManageContributionsRequestEditsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'role': json['role'],
        'personaId': !exists(json, 'persona_id') ? undefined : json['persona_id'],
        'dataCategory': !exists(json, 'data_category') ? undefined : json['data_category'],
        'sourceUrl': !exists(json, 'source_url') ? undefined : json['source_url'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function ManageContributionsRequestEditsInnerToJSON(value?: ManageContributionsRequestEditsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'role': value.role,
        'persona_id': value.personaId,
        'data_category': value.dataCategory,
        'source_url': value.sourceUrl,
        'notes': value.notes,
    };
}

